import { __assign } from "tslib";
export var characters = function (text) {
    return text.map(function (_a) {
        var children = _a.children;
        return children.map(function (_a) {
            var text = _a.text;
            return text;
        }).join('');
    }).join(' ');
};
export var defaulHtml = "<p class='text-left' style=\"width: 100%;\"></p>";
export var defaultChild = [
    { color: '#000000', fontFamily: 'Arial', bold: false, italic: false, underline: false, text: '' },
];
export var defaultBlock = [
    { type: 'paragraph', list: 'paragraph', align: 'left', tabs: 0, children: defaultChild },
];
export var t = "data-slate-node=\"text\"";
export var t1 = "data-slate-node=\"element\"";
export var t2 = "data-slate-leaf=\"true\"";
export var t3 = "data-slate-string=\"true\"";
export function getHTML(id) {
    var div = document.getElementById('slate' + id);
    if (div !== null)
        return div.innerHTML.replaceAll(t, '').replaceAll(t1, '').replaceAll(t2, '').replaceAll(t3, '');
    return '';
}
export var getText = function (text) {
    return text.map(function (b) {
        return __assign(__assign({}, b), { children: b.children.map(function (c) {
                return __assign(__assign({}, c), { text: c.text.replaceAll('"', '¤') });
            }) });
    });
};
export var setText = function (text) {
    return text.map(function (b) {
        return __assign(__assign({}, b), { children: b.children.map(function (c) {
                return __assign(__assign({}, c), { text: c.text.replaceAll('¤', '"') });
            }) });
    });
};
export var getTextFormat = function (text) {
    return text.map(function (_a) {
        var children = _a.children;
        return children.map(function (c) { return c.text; }).join('');
    }).join('');
};
//# sourceMappingURL=Data.js.map